/**
 * Fetch `init` shape that also accepts the `RequestInitEsque` objects tRPC
 * links pass to custom `fetch` implementations. Its `body` may be a
 * `Uint8Array`, which the DOM `BodyInit` type no longer accepts directly.
 */
export type FetchInitEsque =
  | RequestInit
  | {
      body?: BodyInit | Uint8Array | null;
      headers?: HeadersInit | Record<string, string> | [string, string][];
      method?: string;
      signal?: AbortSignal;
    };

function bytesToArrayBuffer(bytes: Uint8Array): ArrayBuffer {
  const copy = new Uint8Array(bytes.byteLength);
  copy.set(bytes);
  return copy.buffer;
}

/** Converts a `FetchInitEsque` into a strict `RequestInit` accepted by `fetch`. */
export function normalizeFetchInit(
  init?: FetchInitEsque,
): RequestInit | undefined {
  if (!init) {
    return undefined;
  }

  const body = "body" in init ? init.body : undefined;
  if (body instanceof Uint8Array) {
    return {
      ...init,
      body: bytesToArrayBuffer(body),
    };
  }

  return init as RequestInit;
}
